import { logger } from './logger';
import { STORY_PIPELINE, STORY_TRANS_PIPELINE, generatePipelineRoutes } from './pipeline';
function genProcess(fn, route, overrides = {}) {
    return {
        route,
        callbackFunction: `${fn}-callback`,
        entryFunction: fn,
        bodyKey: fn.includes('show') ? 'showId' : 'storyId',
        ...overrides,
    };
}
export const PROCESS_ROUTES = {
    ...generatePipelineRoutes(STORY_PIPELINE),
    ...generatePipelineRoutes(STORY_TRANS_PIPELINE),
    'gen-story-ideas': genProcess('gen-story-ideas', '/gen-text', { bodyKey: 'showId' }),
    'gen-story-translation': genProcess('gen-story-translation', '/gen-text'),
    'gen-show-profile': genProcess('gen-show-profile', '/gen-text'),
    'gen-show-ideas': genProcess('gen-show-ideas', '/gen-text'),
    'gen-show-image': genProcess('gen-show-image', '/gen-image'),
    'gen-show-translation': genProcess('gen-show-translation', '/gen-text'),
    'gen-show-announce': genProcess('gen-show-announce', '/gen-tts'),
    'gen-show-theme-music': genProcess('gen-show-theme-music', '/gen-music'),
    'clustering': {
        route: '/clustering',
        callbackFunction: null,
    },
    'gen-cluster-descriptions': {
        route: '/gen-text',
        callbackFunction: 'gen-cluster-descriptions-callback',
    },
    'story_script': { route: '/gen-text', callbackFunction: null },
    'story_outline': { route: '/gen-text', callbackFunction: null },
    'story_ideas': { route: '/gen-text', callbackFunction: null },
    'story_translation': { route: '/gen-text', callbackFunction: null },
    'show_translation': { route: '/gen-text', callbackFunction: null },
    'show_profile': { route: '/gen-text', callbackFunction: null },
    'show_ideas': { route: '/gen-text', callbackFunction: null },
    'show_image': { route: '/gen-image', callbackFunction: null },
    'story_announce': { route: '/gen-tts', callbackFunction: null },
    'show_announce': { route: '/gen-tts', callbackFunction: null },
    'debug-text': { route: '/gen-text', callbackFunction: null },
    'debug-gen-show-announce': { route: '/gen-tts', callbackFunction: null },
    'debug-gen-story-announce': { route: '/gen-tts', callbackFunction: null },
    'debug-gen-tts': { route: '/gen-tts', callbackFunction: null },
    'debug-gen-image': { route: '/gen-image', callbackFunction: null },
    'script-generation': { route: '/gen-text', callbackFunction: null },
    'tts-generation': { route: '/gen-tts', callbackFunction: null },
    'image-generation': { route: '/gen-image', callbackFunction: null },
    'ideas-generation': { route: '/gen-text', callbackFunction: null },
    'translation-generation': { route: '/gen-text', callbackFunction: null },
    'profile-generation': { route: '/gen-text', callbackFunction: null },
    'show-ideas-generation': { route: '/gen-text', callbackFunction: null },
    'show-translation-generation': { route: '/gen-text', callbackFunction: null },
    'music-generation': { route: '/gen-music', callbackFunction: null },
    'story-announce': { route: '/gen-tts', callbackFunction: null },
    'story-outline': { route: '/gen-text', callbackFunction: null },
    'story-embedding': { route: '/gen-embedding', callbackFunction: null },
    'audio-mixing': { route: '/audio-mixing', callbackFunction: null },
    'audio-mixing-internal': { route: '/audio-mixing', callbackFunction: null },
    'audio-mixing-external': { route: '/audio-mixing', callbackFunction: null },
    'cluster-description': { route: '/gen-text', callbackFunction: 'gen-cluster-descriptions-callback' },
    'pre-publish': { route: '', callbackFunction: null },
};
export const LEGACY_PROCESS_ALIASES = {
    'gen-story-outline': ['story-outline'],
    'gen-story-embedding': ['story-embedding'],
    'gen-story-image': ['image-generation'],
    'gen-story-announce': ['story-announce'],
    'gen-story-script': ['script-generation'],
    'gen-story-voice': ['tts-generation'],
    'gen-story-mixed-audio': ['audio-mixing-internal'],
    'gen-story-mixed-audio-external': ['audio-mixing-external'],
    'gen-story-ideas': ['ideas-generation'],
    'gen-story-translation': ['translation-generation'],
    'gen-show-profile': ['profile-generation'],
    'gen-show-ideas': ['show-ideas-generation'],
    'gen-show-image': ['image-generation'],
    'gen-show-translation': ['show-translation-generation'],
    'gen-show-theme-music': ['music-generation'],
    'story-pre-publish': ['pre-publish'],
};
export function getProcessRoute(processType) {
    const config = PROCESS_ROUTES[processType];
    if (config) {
        return config.route || null;
    }
    if (processType.includes('_')) {
        logger.warn(`getProcessRoute: '${processType}' is not in PROCESS_ROUTES — assuming promptId convention and routing to /gen-text`, { processType });
        return '/gen-text';
    }
    return null;
}
export function isDirectProcess(processType) {
    const config = PROCESS_ROUTES[processType];
    return Boolean(config && !config.route);
}
export function getCallbackFunction(processType) {
    const config = PROCESS_ROUTES[processType];
    return config?.callbackFunction ?? null;
}
export function getEntryFunctionConfig(processType) {
    const config = PROCESS_ROUTES[processType];
    if (!config?.entryFunction || !config?.bodyKey) {
        return null;
    }
    const result = {
        endpoint: config.entryFunction,
        bodyKey: config.bodyKey,
    };
    if (config.params) {
        result.params = config.params;
    }
    return result;
}
//# sourceMappingURL=process-config.js.map